import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

import { TextField, Button, Autocomplete } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import { Asset } from "../../../all_Interfaces";
import { useDispatch } from "react-redux";
import { updateInvestmentAsset } from "../../../redux/slices/InvestmentMasterAssetSlice";
import { AlertDialog } from "components/util/Dialog";

export const InvestmentAssetValuesTableForm = (props: any) => {
  const [rows, setRows] = useState<Asset[]>([]);
  const dispatch = useDispatch();
  const deleteIndex = React.useRef();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const assets: Asset[] = useAppSelector(
    (state) => state.UpdateInvestmentAsset.data
  );
  const handleAddRow = () => {
    const item: Asset = {
      id: "",
      name: "",
      status: "",
      investmentId: "",
      currentAppraisalValue: 0,
      lastAppraisedValue: 0,
      lastAnnualAppraisedValue: 0,
      createdBy: "",
      created: "",
      lastModifiedBy: "",
      lastAppraisalDate: "",
      lastAnnualAppraisalDate: "",
      lastModified: "",
    };
    setRows([...rows, item]);
    dispatch(updateInvestmentAsset([...rows, item]));
  };

  const handleRemoveSpecificRow = (idx: any) => {
    const tempRows = [...rows]; // to avoid  direct state mutation
    tempRows.splice(idx, 1);
    setRows(tempRows);
    dispatch(updateInvestmentAsset(tempRows));
  };

  const openDialogFunction = (index:any) => {
    deleteIndex.current = index;
    setOpenDialog(true);
  }
  const closeDialog = () => {
    setOpenDialog(false);
  };


  const handleConfirm = () => {
    setOpenDialog(false);
   handleRemoveSpecificRow(deleteIndex.current);
  };


  useEffect(() => {
    if (Array.isArray(assets)) {
      setRows(assets);
    }
  }, [assets]);
  const assetStatusList = [
    "Active",
    "Held for Sale",
    "New",
    "Pending Acquisition",
    "Retired/Sold",
    "Sold-Inactive",
  ];

  const handleAssetIdChange = (id: string, i: any) => {
    const tempRows: Asset[] = [...rows];
    tempRows[i] = { ...rows[i], id: id };
    setRows(tempRows);
    dispatch(updateInvestmentAsset(tempRows));
    // props.setValidators(
    //   props.validators.map((obj: { label: string }) =>
    //     obj.label === "Assets" ? { ...obj, isEmpty: id != "" ? false : true, valid:id != "" } : { ...obj }
    //   )
    // );
  };
  const handleAssetNameChange = (name: string, i: any) => {
    const tempRows: Asset[] = [...rows];
    tempRows[i] = { ...rows[i], name: name };
    setRows(tempRows);
    dispatch(updateInvestmentAsset(tempRows));
    // props.setValidators(
    //   props.validators.map((obj: { label: string }) =>
    //     obj.label === "Assets" ? { ...obj, isEmpty: name != "" ? false : true, valid:name != ""} : { ...obj }
    //   )
    // );
  };
  const handleAssetStatusChange = (status: string, i: any) => {
    const tempRows: Asset[] = [...rows];
    tempRows[i] = { ...rows[i], status: status };
    setRows(tempRows);
    dispatch(updateInvestmentAsset(tempRows));
    // props.setValidators(
    //   props.validators.map((obj: { label: string }) =>
    //     obj.label === "Assets" ? { ...obj, isEmpty: status != ""  ? false : true, valid:status != "" } : { ...obj }
    //   )
    // );
  };

  const handleAssetLastAppraisalDate = (d: Dayjs | null, i: any) => {
    if (d != null) {
      const tempRows: Asset[] = [...rows];
      tempRows[i] = { ...rows[i], lastAppraisalDate: d.format("MM-DD-YYYY") };
      setRows(tempRows);
      dispatch(updateInvestmentAsset(tempRows));
    }
  };
  const handleAssetLastAnnualAppraisalDate = (d: Dayjs | null, i: any) => {
    if (d != null) {
      const tempRows: Asset[] = [...rows];
      tempRows[i] = {
        ...rows[i],
        lastAnnualAppraisalDate: d.format("MM-DD-YYYY"),
      };
      setRows(tempRows);
      dispatch(updateInvestmentAsset(tempRows));
    }
  };

  const handleAssetLastAnnualAppraisalValue = (value: number, i: any) => {
    const tempRows: Asset[] = [...rows];
    tempRows[i] = { ...rows[i], lastAnnualAppraisedValue: value };
    setRows(tempRows);
    dispatch(updateInvestmentAsset(tempRows));
  };

  const handleAssetLastAppraisalValue = (value: number, i: any) => {
    const tempRows: Asset[] = [...rows];
    tempRows[i] = { ...rows[i], lastAppraisedValue: value };
    setRows(tempRows);
    dispatch(updateInvestmentAsset(tempRows));
  };
  return (<>
  {
          <AlertDialog
            isOpen={openDialog}
            handleClose={closeDialog}
            onConfirm={handleConfirm}
            title={"Attention"}
            message={"Are you sure that you want to delete asset"
            }
          />
        }
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 650 }}
        size="small"
        aria-label="a dense table"
        className="investment-aseet-property-table"
      >
        <TableHead>
          <TableRow>
            <TableCell>Asset ID <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>Asset Name <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>Status <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>Last Appraised Value</TableCell>
            <TableCell>Last Appraisal Date</TableCell>
            <TableCell>Last Annual Appraised Value</TableCell>
            <TableCell>Last Annual Appraisal Date</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((asset: Asset, index: any) => (
            <TableRow>
              <TableCell>
                <TextField
                  value={asset.id}
                  InputProps={{
                    readOnly: props.page === "view",
                  }}
                  size="small"
                  fullWidth
                  error={props.submit && asset.id === ""}
                  onChange={(e) => handleAssetIdChange(e.target.value, index)}
                  required
                />
              </TableCell>
              <TableCell>
                <TextField
                  InputProps={{
                    readOnly: props.page === "view",
                  }}
                  value={asset.name}
                  size="small"
                  fullWidth
                  error={props.submit && asset.name === ""}
                  onChange={(e) => handleAssetNameChange(e.target.value, index)}
                  required
                />
              </TableCell>
              <TableCell>
                <Autocomplete
                  id="assetStatus"
                  className="assetStatus"
                  readOnly={props.page === "view"}
                  options={assetStatusList}
                  value={asset.status}
                  sx={{ width: 150 }}
                  onChange={(event, value) => {
                    handleAssetStatusChange(value != null ? value : "", index);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      required
                      fullWidth
                      error={props.submit && asset.status === ""}
                    />
                  )}
                />
              </TableCell>
              <TableCell>
                <TextField
                  value={asset.lastAppraisedValue}
                  size="small"
                  InputProps={{
                    readOnly: props.page === "view",
                  }}
                  onChange={(e) =>
                    handleAssetLastAppraisalValue(
                      parseFloat(e.target.value),
                      index
                    )
                  }
                  fullWidth
                  type="number"
                />
              </TableCell>
              <TableCell>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      readOnly={props.page === "view"}
                      value={
                        asset.lastAppraisalDate === "" ||
                          asset.lastAppraisalDate === null
                          ? null
                          : dayjs(asset.lastAppraisalDate,
                            "MM-DD-YYYY"
                          )}
                      views={['month', 'day', 'year']}
                      name="lastAppraisalDate"
                      className="table-custom-date"
                      format="MMM-DD-YYYY"
                      slotProps={{ textField: { size: "small" } }}
                      onChange={(newValue: Dayjs | null) =>
                        handleAssetLastAppraisalDate(newValue, index)
                      }
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </TableCell>
              <TableCell>
                <TextField
                  value={asset.lastAnnualAppraisedValue}
                  size="small"
                  InputProps={{
                    readOnly: props.page === "view",
                  }}
                  onChange={(e) =>
                    handleAssetLastAnnualAppraisalValue(
                      parseFloat(e.target.value),
                      index
                    )
                  }
                  fullWidth
                  type="number"
                />
              </TableCell>
              <TableCell>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      readOnly={props.page === "view"}
                      value={
                        asset.lastAnnualAppraisalDate === "" ||
                          asset.lastAppraisalDate === null
                          ? null
                          : dayjs(asset.lastAnnualAppraisalDate,
                            "MM-DD-YYYY"
                          )}
                      views={['month', 'day', 'year']}
                      format="MMM-DD-YYYY"
                      name="lastAnnualAppraisalDate"
                      slotProps={{ textField: { size: "small" } }}
                      onChange={(newValue: Dayjs | null) =>
                        handleAssetLastAnnualAppraisalDate(newValue, index)
                      }
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </TableCell>
              {props.page != "view" && (
                <TableCell>
                  <DeleteIcon
                    sx={{ padding: 1, marginTop: 1 }}
                    onClick={() => openDialogFunction(index)}
                  />
                </TableCell>
              )}
            </TableRow>
          ))}
          {props.page != "view" && (
            <TableRow>
              <TableCell colSpan={8} align="center">
                <Button sx={{textTransform:"none"}}
                  variant="contained"
                  size="small"
                  className="asset-btn"
                  onClick={() => handleAddRow()}
                >
                  <AddIcon />
                  Add New Asset
                </Button>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
</>  );
};
